export default function detectChromeVersion() {
    var _a;
    if (typeof window === "undefined" || ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) == null) {
        return 0;
    }
    const ua = window.navigator.userAgent;
    const isChrome = ua.indexOf("Chrome") !== -1 && ua.indexOf("Edg") === -1;
    if (isChrome) {
        const matches = / Chrome\/(\d*)/.exec(ua);
        if (matches != null && matches.length > 1) {
            return parseInt(matches[1]);
        }
        return 100;
    }
    return 0;
}
